import { render, staticRenderFns } from "./TheModalWindow.vue?vue&type=template&id=3633545e&scoped=true&"
import script from "./TheModalWindow.vue?vue&type=script&lang=js&"
export * from "./TheModalWindow.vue?vue&type=script&lang=js&"
import style0 from "./TheModalWindow.vue?vue&type=style&index=0&id=3633545e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3633545e",
  null
  
)

export default component.exports